import * as moment from 'moment';
import { ValidationRules, ValidationController, ValidationControllerFactory, validateTrigger, Validator } from 'aurelia-validation';

ValidationRules.customRule(
    'numeric',
    (value, obj) => value === null || value === undefined || !isNaN(parseFloat(value)) && isFinite(value),
    `\${$displayName} must be numeric.`
);

ValidationRules.customRule(
    'date',
    (value, obj) => value === null || value === undefined || moment(value).isValid(),
    `\${$displayName} must be a valid date.`
);

ValidationRules.customRule(
    'phone',
    (value, obj) => {
        let digits = (value || "").toString().trim().replace(/\D/g, '');

        if (digits ) {
            return digits.length == 10; //only support 10-digit phones 
        }
        return true;
    },
    `\${$displayName} must be a valid phone #, including area code.`
);

ValidationRules.customRule(
    'isChecked',
    (value, obj) => value,
    `\${$displayName} must be checked.`
);

ValidationRules.customRule(
    'arrayIsNotEmpty',
    (value, obj) => value.length > 0,
    `\${$displayName} must be specified.`
);


ValidationRules.customRule(
    'matchesProperty',
    (value, obj, otherPropertyName) =>
        (value === null || value === undefined || value === '')
        || obj[otherPropertyName] === null
        || obj[otherPropertyName] === undefined
        || obj[otherPropertyName] === ''
        || value === obj[otherPropertyName],
    '${$displayName} must match ${$getDisplayName($config.otherPropertyName)}',
    otherPropertyName => ({ otherPropertyName })
);

